module.exports = __webpack_public_path__ + "static/Tables.7c34a90d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Tables.jpg
// module id = 405
// module chunks = 65579394461380